import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const aristaCloudVision = defineConnector({
  identifier: "aristaCloudVision",
  name: "Arista CloudVision",
  tagLine: "Network management and telemetry",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: ({ host }) => domainToRegex(host),
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Create a service account token",
      items: [
        {
          kind: "markdown",
          content:
            "In your CloudVision portal, navigate to **Settings > Access Control > Service Accounts**. Create a service account with the appropriate role, then generate a token for it.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "CloudVision host",
          required: true,
          placeholder: "www.arista.io",
          helperText:
            "Your CloudVision hostname (e.g., www.arista.io for CVaaS, or your on-prem hostname).",
          target: { kind: "configuration", field: "host" },
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
          helperText: "The service account token from CloudVision.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}/api/resources/admin/v1/admin`,
  },
});
